import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  \n  ", "\n\n  ", "\n\n  ", "\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../utils/styling/styled-components';
import { arrowPlacementResolvers, arrowColorResolvers } from './utils';
import { ARROW_SIZE } from './constants';
var WidthOffsetPositions = ['bottom-end', 'bottom-start', 'top-end', 'top-start'];
var HeightOffsetPositions = ['left-end', 'left-start', 'right-end', 'right-start'];
var StyledTooltipArrow = styled.div(_templateObject(), function (_ref) {
  var placement = _ref.placement;
  return WidthOffsetPositions.includes(placement) ? 'width: 27px;' : '';
}, function (_ref2) {
  var placement = _ref2.placement;
  return HeightOffsetPositions.includes(placement) ? 'height: 16px;' : '';
}, function (_ref3) {
  var placement = _ref3.placement;
  return arrowPlacementResolvers[placement]();
}, function (_ref4) {
  var placement = _ref4.placement,
      arrowColor = _ref4.arrowColor;
  return "\n    &::after {\n      border: ".concat(ARROW_SIZE, "px solid transparent;\n      box-sizing: border-box;\n      content: '';\n      position: absolute;\n      height: ").concat(ARROW_SIZE * 2, "px;\n      width: ").concat(ARROW_SIZE * 2, "px;\n      ").concat(arrowColorResolvers[placement](arrowColor), "\n    }\n  ");
});
export var TooltipArrow = function TooltipArrow(_ref5) {
  var getArrowProps = _ref5.getArrowProps,
      arrowColor = _ref5.arrowColor,
      placement = _ref5.placement;
  return /*#__PURE__*/React.createElement(StyledTooltipArrow, _extends({
    arrowColor: arrowColor,
    placement: placement
  }, getArrowProps()));
};